import React, { useState } from 'react';
import './Contact.css';
import CallIcon from '../assets/Call.svg';
import LocationIcon from '../assets/Location.svg';
import MessageIcon from '../assets/Message.svg';
import SuccessGif from '../assets/Newsletter subscribe (2).gif';

const Contact = () => {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    message: ''
  });

  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'nom':
      case 'prenom':
        if (!value.trim()) {
          error = 'Ce champ est requis';
        } else if (value.trim().length < 2) {
          error = 'Minimum 2 caractères requis';
        }
        break;
      case 'email':
        if (!value.trim()) {
          error = 'Ce champ est requis';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = 'Format d\'email invalide';
        }
        break;
      case 'telephone':
        if (!value.trim()) {
          error = 'Ce champ est requis';
        } else if (!/^(\+216)?[0-9\s]{8,}$/.test(value.replace(/\s/g, ''))) {
          error = 'Format de téléphone invalide';
        }
        break;
      case 'message':
        if (!value.trim()) {
          error = 'Ce champ est requis';
        } else if (value.trim().length < 10) {
          error = 'Minimum 10 caractères requis';
        }
        break;
      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // Validate on change
    const error = validateField(name, value);
    setErrors({
      ...errors,
      [name]: error
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    const newErrors = {};
    let hasErrors = false;

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      newErrors[key] = error;
      if (error) hasErrors = true;
    });

    setErrors(newErrors);

    if (!hasErrors) {
      setIsLoading(true);

      try {
        // Send data to API
        const response = await fetch('/api/send-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (response.ok) {
          // Success - show popup and reset form
          setShowPopup(true);
          setFormData({
            nom: '',
            prenom: '',
            email: '',
            telephone: '',
            message: ''
          });
        } else {
          // API error
          console.error('API Error:', data);
          alert('Une erreur est survenue lors de l\'envoi de votre message. Veuillez réessayer.');
        }
      } catch (error) {
        // Network error
        console.error('Network Error:', error);
        alert('Erreur de connexion. Veuillez vérifier votre connexion internet et réessayer.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <h1 className="title">
          Votre Demande, Notre Attention
        </h1>
        <img
          src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Contact.png"
          alt="Contact"
          className="contact-hero-image"
        />
      </section>

      {/* Form Section */}
      <section className="contact-form-section">
        <div className="contact-container">
          <div className="contact-info-panel">
            <h2 className="panel-title">Contactez-Nous</h2>
            <p className="panel-description">
              Pour toute demande d'information juridique ou pour prendre rendez-vous, veuillez contacter le cabinet.
            </p>

            <div className="contact-details">
              <div className="contact-detail-item">
                <img src={CallIcon} alt="Phone" className="contact-detail-icon" />
                <span>+216 71 785 257</span>
              </div>
              <div className="contact-detail-item">
                <img src={LocationIcon} alt="Location" className="contact-detail-icon" />
                <span>17 Rue Hassen Ibn Noomen, Tunis Tunisia 1002</span>
              </div>
              <div className="contact-detail-item">
                <img src={MessageIcon} alt="Email" className="contact-detail-icon" />
                <span>Contact@cabinetbennasr.com</span>
              </div>
            </div>

            <div className="contact-hours">
              <h3 className="hours-title">Horaires</h3>
              <p className="hours-text">
                Lundi – Vendredi<br />
                08h00 – 17h00
              </p>
              <p className="hours-footnote">
                Des rendez-vous en dehors des horaires habituels peuvent être organisés sur demande.
              </p>
            </div>
          </div>

          <div className="contact-form-panel">
            <h2 className="form-title">Demande de Consultation</h2>
            <p className="form-description">
              Pour toute consultation juridique, nous vous invitons à contacter le cabinet par téléphone ou par email afin de convenir d'un rendez-vous.
            </p>
            <p className="form-instructions">
              Afin de faciliter le traitement de votre demande, merci d'indiquer :<br />
              - Votre nom complet<br />
              - Vos coordonnées<br />
              - Une brève description de votre demande
            </p>
            <p className="form-confidentiality">
              Toutes les communications sont traitées avec la plus stricte confidentialité.
            </p>

            <form onSubmit={handleSubmit} className="consultation-form">
              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="nom">Nom</label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    placeholder="Votre nom"
                    className={errors.nom ? 'error' : ''}
                  />
                  {errors.nom && <span className="error-message">{errors.nom}</span>}
                </div>
                <div className="form-field">
                  <label htmlFor="prenom">Prénom</label>
                  <input
                    type="text"
                    id="prenom"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    placeholder="Votre prénom"
                    className={errors.prenom ? 'error' : ''}
                  />
                  {errors.prenom && <span className="error-message">{errors.prenom}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="votre.email@exemple.com"
                    className={errors.email ? 'error' : ''}
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
                <div className="form-field">
                  <label htmlFor="telephone">Téléphone</label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    placeholder="+216 XX XXX XXX"
                    className={errors.telephone ? 'error' : ''}
                  />
                  {errors.telephone && <span className="error-message">{errors.telephone}</span>}
                </div>
              </div>

              <div className="form-field form-field-full">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Décrivez brièvement votre demande..."
                  rows="6"
                  className={errors.message ? 'error' : ''}
                ></textarea>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>

              <button type="submit" className="form-submit-button" disabled={isLoading}>
                {isLoading ? 'Envoi en cours...' : 'Envoyer'}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Success Popup */}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={closePopup}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#304156" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <img src={SuccessGif} alt="Success" className="popup-gif" />
            <h2 className="popup-title">Votre message a été transmis avec succès</h2>
            <p className="popup-text">
              Merci d'avoir contacté le cabinet. Votre demande est en cours de traitement et nous vous répondrons dans les meilleurs délais.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
